<template>
    <el-dialog title="添加项目"  class="global-dialog project-form"
                :visible.sync="dialogVisible"
                :append-to-body="true" width="640px">
        <div class="p-f-body">
            <el-form :model="myForm" :rules="formRules" ref="myForm" label-width="100px">
                <el-form-item label="项目名称" prop="name">
                    <el-input v-model="myForm.name" placeholder="请输入项目名称"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
                <el-button @click="resetForm('myForm')">取消</el-button>
                <el-button type="primary" @click="submitForm('myForm')" :loading="loading">确认</el-button>
        </div>
        <project-alert v-model="projectAlertVal"></project-alert>
    </el-dialog>
</template>
<script>
    import projectService from '../../request/service/project-service'
    import projectAlert from './project-repeatition-alert'
    import {error_code_40001} from '@/const.js';
    export default {
        components: {projectAlert},
        props: {
            value: {type: Boolean, default: false}
        },
        data () {
            return {
                loading: false,
                projectAlertVal: false,
                myForm: {
                    name: ''
                },
                formRules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                    ]
                }
            };
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addProject();
                    } else {
                        return false;
                    }
                });
            },
            addProject () {
                this.loading = true;
                projectService.applyProject(this.myForm).then(() =>{
                    // this.$message.success('添加成功');
                    this.$emit('input', false);
                    let routerHref = this.$router.resolve({name: 'project-apply', query: {applyFlag: true}});
                    window.open(routerHref.href, '_blank');
                }, (error) =>{
                    if (error.code === error_code_40001) {
                        this.projectAlertVal = true;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            resetForm(formName) {
                this.$emit('input', false);
                this.$refs[formName].resetFields();
            }
        }
    }
</script>